// extracted by mini-css-extract-plugin
export default {"container":"sp-z","brandName":"tp-z","productName":"up-z","productNamePdpEnhancements":"vp-z","breakLongProductName":"wp-z"};